export const isIOSWebView = !!window.webkit && !!window.webkit.messageHandlers

export const isAndroidWebView = !!window.AndroidInterface
